/**
 * @generated SignedSource<<11def388a247d1d3c608ca39d32e5fd2>>
 * @relayHash 50aff49926920514ba3020db082cce38
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1713f82b1ea505ce5b37f6edc5acf8c734f1c5803d49ce12d4f2f3353d89c981

import type { ConcreteRequest, Query } from 'relay-runtime';
export type Nav4RecommendationsQuery$variables = {
  cloudId: string;
};
export type Nav4RecommendationsQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly context?: {
        readonly sessionId: string | null | undefined;
      } | null | undefined;
      readonly data?: ReadonlyArray<{
        readonly entityId?: string;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira: {
    readonly canCreateProject: boolean | null | undefined;
  } | null | undefined;
};
export type Nav4RecommendationsQuery = {
  response: Nav4RecommendationsQuery$data;
  variables: Nav4RecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "alias": "canCreateProject",
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Literal",
          "name": "type",
          "value": "CREATE_PROJECT"
        }
      ],
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ]
},
v2 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "product",
        "value": "jira"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "cloudId"
      },
      {
        "kind": "Literal",
        "name": "useCase",
        "value": "jiraProjectMenuRecommendations"
      }
    ],
    "kind": "ObjectValue",
    "name": "context"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "entityId"
    }
  ],
  "type": "GrowthRecJiraTemplateRecommendation"
},
v4 = {
  "concreteType": "GrowthRecContextResult",
  "kind": "LinkedField",
  "name": "context",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sessionId"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "Nav4RecommendationsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  },
                  (v4/*: any*/)
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Nav4RecommendationsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ]
                  },
                  (v4/*: any*/)
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1713f82b1ea505ce5b37f6edc5acf8c734f1c5803d49ce12d4f2f3353d89c981",
    "metadata": {},
    "name": "Nav4RecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8583b77d3fe5ee2fc7422c8b304ac609";

export default node;
